<template>
  <div class="car-detail__page-title">
    <template v-if="pageType === 'car-detail'">
      <h5 class="car-detail__year" v-text="comparisonStore.getCarYearRange(carData?.Vehicle_UID)" />
      <h1 class="car-detail__title" v-text="makeModel" />
      <h2 v-if="trim !== '-'" class="car-detail__subtitle" v-text="trim" />
      <ShareCopy class="no-margin" />
    </template>
    <template v-else>
      <!-- <h5 class="car-detail__year" v-text="comparisonStore.getCarYearRange(carData.Vehicle_UID)" /> -->
      <h1 class="car-detail__title" v-text="makeModel + ' Car Review'" />
      <h2 class="car-detail__subtext" v-text="titleSubtext" />
      <ShareCopy class="no-margin" />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useCarData } from '../../composables/useCarData';
import ShareCopy from '../share/ShareCopy.vue';
import { useCarComparisonStore } from '../../foundation/stores/carComparisonStore';

const props = defineProps({
  carData: {
    type: Object,
    required: true,
  },
  pageType: {
    type: String,
    default: 'car-detail',
  },
  titleSubtext: {
    type: String,
    default: '',
  },
});

const comparisonStore = useCarComparisonStore();

const { makeModel } = useCarData(props.carData);
const trim = computed(() => props.carData.Trim);
</script>

<style lang="scss" scoped>
.car-detail {
  &__page-title {
    margin-bottom: -1rem;
    background-color: $racq-pale-blue;
    padding: 1.5rem 0 1rem;

    @media screen and (min-width: #{$breakpoint-xl}) {
      padding: 1.5rem 0;
    }

    @media screen and (min-width: #{$breakpoint-xxl}) {
      padding: 1.5rem 0 1rem;
    }
  }

  &__year {
    font-size: 1rem;
    color: $racq-navy;
    font-weight: bold;
    margin: 0;
    line-height: 1;
  }

  &__title {
    font-weight: bold;
    font-size: 2rem;
    margin: 0;
  }

  &__subtitle {
    font-size: 1.75rem;
    margin: 0;
    margin-bottom: 1rem;
  }

  &__subtext {
    font-size: 1rem;
    margin: 0;
    margin-bottom: 1rem;
  }
}
</style>
